module.exports = __webpack_public_path__ + "Roboto-Bold.woff";


//////////////////
// WEBPACK FOOTER
// ./~/materialize-css/fonts/roboto/Roboto-Bold.woff
// module id = 89
// module chunks = 0